import React from 'react';

import MainLayout from '../../components/uikit-components/MainLayout/MainLayout';
import { WithUserRolesForSchool } from '../../context/userRoles/WithUserRolesForSchool';
import UserRoles from './UserRoles';

import './index.scss';

const UserRolesPage: React.FC = () => (
  <MainLayout>
    <WithUserRolesForSchool>
      <UserRoles />
    </WithUserRolesForSchool>
  </MainLayout>
);

export default UserRolesPage;
